<label nz-checkbox [formControl]="control">{{ label }}</label>
